let URL = (window.location.href);
let ses_idURL = URL.split('sesId=');

export const ses_id = ses_idURL[1];

  
